module.exports = __webpack_public_path__ + "8a861197f3b5ca6dffaf6fdab2723682.svg";